import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Language } from 'src/shared/constants/languages';
import { DateHelper } from 'src/shared/helpers/date';
import { LanguageHelper } from 'src/shared/helpers/language';
import { NumberHelper } from 'src/shared/helpers/number';
export const useInitHelpers = ({ language = Language.En }) => {
    const { i18n } = useTranslation();
    const [isInitingHelpers, setIsInitingHelpers] = useState(true);
    useEffect(function initHelpers() {
        const normalizeLocale = LanguageHelper.normalizeLocale(language);
        NumberHelper.setLocale(normalizeLocale);
        DateHelper.setLocale(normalizeLocale);
        LanguageHelper.setLanguage(normalizeLocale, i18n);
        setIsInitingHelpers(false);
    }, [i18n, language]);
    return { isInitingHelpers };
};
export default useInitHelpers;
